<div class="field" [class.invalid]="invalid()" [class.disabled]="isDisabled()"
  cdkOverlayOrigin #origin="cdkOverlayOrigin" (click)="onFieldClick()">
  <input #input type="text" class="field-input" autocomplete="off"
    role="combobox" aria-haspopup="listbox" aria-autocomplete="none"
    [attr.inputmode]="effectiveHourFormat() === '12h' ? 'text' : 'numeric'"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="open() ? listId : null"
    [attr.aria-activedescendant]="open() ? activeOptionId() : null"
    [attr.aria-invalid]="invalid()"
    [attr.aria-label]="ariaLabel()"
    [value]="text()"
    [placeholder]="placeholder()"
    [disabled]="isDisabled()"
    (input)="type($any($event.target).value)"
    (mousedown)="onInputMousedown($event)"
    (keydown)="onKeydown($event)"
    (blur)="onBlur()"/>

  @if (!bare()) {
    <!-- Keeps focus in the input: a mousedown here would blur it, which commits and closes. -->
    <button type="button" class="toggle" tabindex="-1" [disabled]="isDisabled()"
      i18n-aria-label aria-label="Choose a time"
      (mousedown)="$event.preventDefault()" (click)="toggleList(); $event.stopPropagation()">
      <i class="material-icons">schedule</i>
    </button>
  }
</div>

<!-- No backdrop: the field stays clickable and typeable under the open list; blur closes it. -->
<ng-template cdkConnectedOverlay appOverlayPanel matchTriggerWidth [backdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  (panelClose)="closeList()">
  <!-- mousedown is cancelled on the whole list, scrollbar included, so the field keeps focus. -->
  <ul #list class="time-list" role="listbox" [id]="listId" i18n-aria-label aria-label="Times"
    (mousedown)="$event.preventDefault()">
    @for (option of listOptions(); track option.value; let index = $index) {
      <li role="option" [id]="optionId(index)"
        [attr.aria-selected]="option.value === time()"
        [class.checked]="option.value === time()"
        [class.active]="index === activeIndex()"
        (click)="pick(option)">
        <i class="material-icons-outlined check">check</i>
        <span class="title">{{ option.label }}</span>
      </li>
    } @empty {
      <li class="empty" i18n>No times to choose from</li>
    }
  </ul>
</ng-template>
